module.exports = __webpack_public_path__ + "img/middleschool.01e4ebb2.png";